<div class="svgIconComponent" v-if="iconsFolderPath &amp;&amp; name" :style="iconStyles"><div class="svg" v-html="html"></div></div>